import { render, staticRenderFns } from "./Experiencies.vue?vue&type=template&id=b72d27ae&scoped=true&"
import script from "./Experiencies.vue?vue&type=script&lang=js&"
export * from "./Experiencies.vue?vue&type=script&lang=js&"
import style0 from "./Experiencies.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Experiencies.vue?vue&type=style&index=1&id=b72d27ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d27ae",
  null
  
)

export default component.exports